<app-menu></app-menu>
<div class='container main-content'>
  <router-outlet></router-outlet>
</div>
